/*
 * @Author: czj
 * @Date: 2025-04-17 14:50:45
 * @Description: 
 * @FilePath: \sxtracellular-single-cell\src\locales\language\zh.js
 */
export default {
  "name": "中国脑损伤数据图谱",
  "greeting": '你好，世界！',
  "button": {
    "save": '保存',
    "cancel": '取消'
  },
  "login": {
    "title": "欢迎回来！",
    "tip": "使用您的账户登录！",
    "email": "电子邮件",
    "password": "密码",
    "login": " 登 录 ",
    "forgot": "没有账号？",
    "signup": "立即注册",
    "retrieve": "忘记密码?"
  },
  "topbar": {
    "logout": "退出登录",
    "signin": "登录",
  },
  "route": {
    "dataset": "数据集",
    "analysis": "分析工具",
    "help": "帮助",
    "contact": "联系我们"
  },
  "home": {
    "dataset": "数据集",
    "cellnum": "细胞数",
    "intro": "简介"
  }
}
